import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as userActions } from '../../../actions/userActions';
import { actions as supportActions } from '../../../actions/supportActions';
import { actions as projectActions } from '../../../actions/projectActions';
import * as types from '../../../constants/actionTypes';
import Drawer from '../../Common/Drawer/Drawer';
import Notification from '../../Common/Notification';
import GeneralSupport from './GeneralSupport';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
export class CustomerSupportDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        const newTicket = {
            locationId: "",
            projectId: "",
            subject: "",
            description: ""
        }

        this.state = {
            locations: [],
            projects: [],
            faqs: [],
            isProjectEnabled: false,
            ticket: newTicket,
            isFormValid: true,
            isLoadingProjects: false,
            isLoadingFilters: false,
            userName: "",
            userEmail: "",
            subName: ""
        }
    }

    async componentDidMount() {
        await this.loadFilters();
    }

    onFormChange = (name, value) => {
        this.setState({ ticket: { ...this.state.ticket, [name]: value } }, () => {
            if(name === "locationId"){
                this.loadProjectsForLocation();  
            }            
        });
    }

    async loadFilters() {
        this.setState({ isLoadingFilters: true });
        try {
            const result = await this.props.userActions.loadSupportFilters();
            const payload = result.payload;
            if (result.type === types.LOAD_USER_SUPPORT_FILTERS_SUCCESS) {
                const locationId = (payload.defaultLocationId) ? payload.defaultLocationId : "";
                this.setState({ 
                    locations: payload.assignedLocations, 
                    faqs: payload.questions,
                    isProjectEnabled: payload.isProjectEnabled,
                    userName: payload.userName,
                    userEmail: payload.userEmail,
                    subName: payload.subscriptionName,
                    ticket: { ...this.state.ticket, locationId: locationId }
                 }, () => {
                    if(locationId){
                        this.loadProjectsForLocation();        
                    }                 
                 });
            } else if (result.type === types.LOAD_USER_SUPPORT_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingFilters: false });
        }
    }

    async loadProjectsForLocation(){
        this.setState({ 
            isLoadingProjects: true,
            ticket: { ...this.state.ticket, projectId: "" }
        });
        try {
            const result = await this.props.projectActions.searchByLocation(this.state.ticket.locationId);
            const payload = result.payload;
            if (result.type === types.LOAD_PROJECT_LIST_SUCCESS) {
                // if there is only 1 project, select it, otherwise make them choose
                const projectId = (payload.projects && payload.projects.length == 1) ? payload.projects[0].id : "";
                this.setState({ 
                    projects: payload.projects,
                    ticket: { ...this.state.ticket, projectId: projectId }
                });
            } else if (result.type === types.LOAD_PROJECT_LIST_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingProjects: false });
        }
    }

    validateGeneralForm = (ticket) => {
        const { subject, description, locationId } = ticket;

        if (subject && subject.trim().length > 0
            && description && description.trim().length > 0
            && locationId
        ) {
            return true;
        }

        return false;
    }

    createSubscriptionTicket = async () => {
        if (this.validateGeneralForm(this.state.ticket)) {
            const response = await this.props.supportActions.createSubscriptionTicket(this.state.ticket);
            if (response.type === types.CREATE_SUBSCRIPTION_TICKET_SUCCESS) {

                Notification("success", "Ticket Created", "Thank you for submitting your support request.  Please allow 2 business days for a response.");
                this.props.onComplete();

            } else if (response.type === types.CREATE_SUBSCRIPTION_TICKET_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } else {
            this.setState({ isFormValid: false, isLoading: false });
        }
    }

    render() {
        return (
            <Drawer isWide={true}
                title='Support'
                onSaveClick={this.createSubscriptionTicket}
                saveText="Send Ticket"
                onCancelClick={this.props.onComplete}>

                <LoadingIndicator isLoading={this.state.isLoadingFilters}>
                    <GeneralSupport
                        locations={this.state.locations}
                        projects={this.state.projects}
                        faqs={this.state.faqs}
                        ticket={this.state.ticket}
                        onFormChange={this.onFormChange}
                        isFormValid={this.state.isFormValid}
                        isProjectEnabled={this.state.isProjectEnabled}
                        isLoadingProjects={this.state.isLoadingProjects}
                    />         
                </LoadingIndicator>
            </Drawer>
        )
    }
}

CustomerSupportDrawer.propTypes = {
    userActions: PropTypes.object.isRequired,
    supportActions: PropTypes.object.isRequired,
    projectActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch),
        supportActions: bindActionCreators(supportActions, dispatch),
        projectActions: bindActionCreators(projectActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(CustomerSupportDrawer);
